// @flow

export { externalNigeriaOutgoingPaymentMapper} from './external-nigeria-outgoing-payment-mapper';
